module.exports = __webpack_public_path__ + "img/city_001.29f86945.jpg";